import { mmHost } from '@src/Main/main';

function getHost () {
  // NOTE: this could be useful if you want to run the page from a local execution-engine, but talk to a real box
  // ex:  return '192.168.7.2';
  return mmHost;
}

/**
 * Function to request network information (ssid, ip, netmask, gateway) of a given interface.
 * The request can be aborted and if you do, the error callback will not be called.
 *
 * @param {NetworkNames} pPort Name of the network interface. MMv1 supports 'eth0', MMv2 supports 'LAN_1' or 'LAN_2'.
 * @param {(jsonResponse: string) => void} [pCallback] A success callback.
 * @param {(xhr: XMLHttpRequest, status: string, error: string) => void} [pOnError] A callback for when the request fails.
 * @param {number} [timeout] The maximum time allowed for the request.
 * @returns {() => void} A cancellation function to cancel the request.
 */
function getNetworkInfo (pPort, pCallback = undefined, pOnError = undefined, timeout = 0) {
  const url = 'http://' + getHost() + '/getNetworkInfo?port=' + pPort;
  const request = $.ajax({
    url,
    method: 'GET',
    success: jsonResponse => {
      pCallback?.(jsonResponse);
    },
    error: (xhr, status, error) => {
      if (status !== 'abort') {
        pOnError?.(xhr, status, error);
      }
    },
    timeout,
  });

  return () => {
    request.abort();
  };
}

/**
* Function to setup the IP, netmask and the gateway of a given network interface
* @param pConfiguration     --- Description: the configuration payload.     --- Type: Object let configuration = {machinePort, mode, machineIp, machineGateway, machineNetmask}
*/
function configIp (pConfiguration, pCallback, pOnError) {
  const lUrl = 'http://' + getHost() + '/configIp';
  $.ajax({
    url: lUrl,
    method: 'POST',
    data: pConfiguration,
    success: function (_pData) {
      if (undefined != pCallback) { pCallback(_pData); }
    },
    error: function (xhr, status, error) {
      if (undefined != pOnError) { pOnError(xhr, status, error); }
    },
  });
}

/**
* Function to setup the default gateway
* @param pConfiguration     --- Description: the configuration payload.     --- Type: Object let configuration = {machineGateway}
*/
function configGateway (pConfiguration, pCallback, pOnError) {
  // Only compatible with MMv2
  const lUrl = 'http://' + getHost() + '/configGateway';
  $.ajax({
    url: lUrl,
    method: 'POST',
    data: pConfiguration,
    success: function (_pData) {
      if (undefined != pCallback) { pCallback(_pData); }
    },
    error: function (xhr, status, error) {
      if (undefined != pOnError) { pOnError(xhr, status, error); }
    },
  });
}

function emitWifiRequest (pUrlString, pMethod, pData, pCallback, pOnError) {
  const lUrl = `http://${getHost()}/wifi/pendant/${pUrlString}`;

  const request = $.ajax({
    url: lUrl,
    method: pMethod,
    data: pData,
    success: jsonResponse => pCallback?.(jsonResponse),
    error: (xhr, status, error) => pOnError?.(xhr, status, error),
  });

  return () => {
    request.abort();
  };
}

const wifi = {
  networks: function (pCallback, pOnError) {
    const processResponse = (wifiStatus) => {
      if (!wifiStatus || !wifiStatus.networks) {
        throw new Error(`Error while scanning available WiFi networks, no networks received ${wifiStatus}.`);
      }

      const uniqueSsids = {};
      const networks = wifiStatus.networks.filter(network => {
        if (uniqueSsids[network.ssid]) {
          return false;
        }

        uniqueSsids[network.ssid] = true;
        return true;
      });

      return {
        networks,
        connectedNetwork: networks.find(network => network.ssid === wifiStatus.currentWifiSsid),
      };
    };
    return emitWifiRequest(
      'networks',
      'GET',
      undefined,
      (pJsonResponse) => {
        /* response should be:
          {
            networks     : [ { ssid : String, encryption : String|none } ],
            currentWifiSsid : String|none
          }
        */
        pCallback(processResponse(pJsonResponse));
      },
      pOnError);
  },
  connect: function (pSSID, pPassword, pCallback, pOnError) {
    /* response should be:
            { currentWifiSsid : String|none, error : String|none }
        */
    const params = {
      ssid: pSSID,
      password: pPassword,
      encryption: pPassword ? 'on' : 'off',
    };
    emitWifiRequest('connect', 'POST', params, pCallback, pOnError);
  },
  disconnect: function (pCallback, pOnError) {
    emitWifiRequest('disconnect', 'PUT', undefined, pCallback, pOnError);
  },
};

/*
// NOTE: placeholder for future auto setup
let autoSetup = 'manual';
function getAutoSetupMode(pCallback, pOnError) {
    pCallback(autoSetup);
}
function setAutoSetupMode(pData, pCallback, pOnError) {
    autoSetup = pData;
    pCallback();
}
*/

export default {
  getNetworkInfo,
  configIp,
  configGateway,
  wifi,
};
